import { Fragment } from "react";
import Navbar from "../../components/Navbar";
import ProjectSection from "../../components/ProjectSection";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";
import Logo from "../../images/logo.png";


const ProjectPage = () => {
  return (
    <Fragment>
      <Navbar Logo={Logo} />
      <ProjectSection />
      <Scrollbar />
      <Footer />
    </Fragment>
  );
};
export default ProjectPage;
